import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { getNumberWithCommas } from '../../utilities/money';
import { colorPallateGenerator } from '../../utilities/general';
import { CHAIN_COLORS } from '../../constants/chain_colors';
const PieChartPaddingComponent = (props) => {
  /**
   * Defining Default colors for
   */
  const COLORS = ['#26ABA4', '#3290ED', '#9D53F2', '#77B5F2', '#871b5a', '#5730ff'];

  /**
   * See if the defined color is sufficient for types of chains
   * if not create color and push it to colors array dynamically
   */
  if (COLORS.lenght < props.data01) {
    let extra_colors_needed = props.data01.lenght - COLORS.length;
    for (let i = 0; i < extra_colors_needed; i++) {
      let generated_color = colorPallateGenerator();
      COLORS.push(generated_color);
    }
  }

  const renderLegend = () => {
    const customizedData = props.data01.sort(function (b, a) {
      return b.name.length - a.name.length;
    });

    const marginIndex = customizedData.length === 2 ? '0px 0px 0px 85%' : customizedData.length === 1 ? "0px 0px 0px 150%" : "0px 20px 0px 0px"


    return (
      <div className="custom-legends-items">
        {customizedData.map((entry, index) => (
          <span>
            <li
              key={`item-${index}`}
              className="recharts-legend-item legend-item-0"
              style={{ margin: marginIndex, width: 140, listStyleType: 'none' }}
            >
              <svg
                className="recharts-surface"
                width="14"
                height="14"
                viewBox="0 0 32 32"
                version="1.1"
                style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
              >
                <path
                  stroke="none"
                  fill={CHAIN_COLORS[entry.key]}
                  d="M0,4h32v24h-32z"
                  className="recharts-legend-icon"
                ></path>
              </svg>
              <span className="recharts-legend-item-text" style={{ color: ' rgb(38, 171, 164)' }}>
                {entry.name}
              </span>
            </li>
          </span>
        ))}
      </div>
    );
  };

  /* const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, key }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 2.3;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  
    return (
      <text
        x={x}
        y={y}
        fill={chainColorAssociation[key]}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
      >
        {`$${getNumberWithCommas(value)}`}
      </text>
    );
  };
  */

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <p
          className="label"
          style={{ backgroundColor: '#FFF', padding: '3px 5px' }}
        >{`${payload[0].payload.key.toUpperCase()} $${getNumberWithCommas(
          payload[0].value
        )} : ${payload[0].name.replace(payload[0].payload.key.toUpperCase(), '')}`}</p>
      );
    }
  };
  return (
    <ResponsiveContainer width="100%" height={315}>
      <PieChart width={400} height={400}>
        <Pie
          data={props.data01}
          dataKey="data"
          cx="50%"
          cy="50%"
          outerRadius={60}
          fill="#8884d8"
          minAngle={3}
        >
          {props.data01.map((entry, index) => {
            return <Cell key={`cell-${index}`} fill={CHAIN_COLORS[entry.key]} />;
          })}
        </Pie>
        <Pie
          data={props.data02}
          cx="50%"
          cy="50%"
          innerRadius={70}
          outerRadius={90}
          fill="#82ca9d"
          // label={renderCustomizedLabel}
          minAngle={3}
        >
          {props.data02.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              className={`${entry.label}`}
              fill={CHAIN_COLORS[entry.key]}
            />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend content={renderLegend} align="left" />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PieChartPaddingComponent;
